module.exports = __webpack_public_path__ + "img/dropdown.4bd23f2e.svg";